import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div style={{
      width: "100%",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(to bottom right, #f5f5f5, #dcdcdc)",
      padding: "24px"
    }}>
      <div
        style={{
          maxWidth: "600px",
          width: "100%",
          background: "white",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          padding: "40px",
          textAlign: "center"
        }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1
          style={{ fontSize: "80px", fontWeight: "bold", color: "#333" }}
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          404
        </h1>

        <p style={{ color: "#666", fontSize: "18px", marginTop: "16px" }}>
          Oops! The page you are looking for doesn't exist or has been moved.
        </p>

        <div
          style={{ marginTop: "32px", display: "inline-block" }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              background: "#4f46e5",
              color: "white",
              padding: "12px 24px",
              borderRadius: "10px",
              fontSize: "18px",
              fontWeight: 500,
              textDecoration: "none",
              boxShadow: "0 4px 12px rgba(79,70,229,0.4)",
              transition: "background 0.3s"
            }}
            onMouseEnter={(e) => (e.target.style.background = "#4338ca")}
            onMouseLeave={(e) => (e.target.style.background = "#4f46e5")}
          >
            <ArrowLeft size={20} /> Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}